import React from 'react';
import PropTypes from 'prop-types';

export default class ListingLoadMore extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
    }

    render() {
        const shouldHandleLoadMore = this.props.pagination &&
            (this.props.pagination.currentPage < this.props.pagination.pageCount);

        if (shouldHandleLoadMore) {
            return (
                <div
                    className={`listing-load-more spinner ${this.props.isLoadingMore ? 'is-loading' : ''}`}>
                    <button type="button"
                        className="listing-load-more__button button button--primary"
                        onClick={this.onLoadMoreClick}>
                        load more
                    </button>
                </div>
            );
        }
        return null;
    }

    onLoadMoreClick() {
        this.props.onLoadMore();
    }
}

ListingLoadMore.propTypes = {
    isLoadingMore: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    onLoadMore: PropTypes.func.isRequired,
};
